<template>
    <div class="section">
        <app-loader :loading="getLoaderStatus"
                    :color="options.color"
                    :size="options.size">
        </app-loader>
        <div class="columns" v-if="!getLoaderStatus">
            <shipping-info :car="getCar"></shipping-info>
        </div>
        <div class="columns" v-if="!getLoaderStatus">
            <right-side :car="getCar"></right-side>
            <left-side :car="getCar"></left-side>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import leftSide from './LeftSide'
    import rightSide from './RightSide'
    import ShippingInfo from "./ShippingInfo";
    export default {
        components: {
            ShippingInfo,
            appLoader,
            leftSide,
            rightSide
        },
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            getCar() {
                return this.$store.getters.getSingleCar
            }
        },
        created () {
            this.$store.dispatch('fetchSingleCarData', this.$route.params.id)
        }
    }
</script>

<style scoped>
    .section {
        padding: 60px 0 0;
    }
    .columns {
        margin-left: 0;
        margin-right: 0;
    }
    .columns >>> .card-content {
        padding: 0.8em 0.6em;
    }
    /* mobile-first, reordering for desktop */
    @media screen and (min-width:767px){
        /*.columns >>> .left-side {
            order: 1;
        }
        .columns >>> .right-side {
            order: 2;
        }*/
    }

</style>



// WEBPACK FOOTER //
// src/components/Cars/Car/Car.vue